var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 600"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 2048,
    height: 2048,
    fill: "#633fda"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-clean_next_selected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clean_next_selected",
    clipPath: "url(#clip-clean_next_selected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NextIcon",
    transform: "translate(-543 -664)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Fx_04_Next_with_Text",
    "data-name": "Icons_Fx_04_Next with Text",
    transform: "translate(258.514 193.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(42.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    transform: "translate(247.05 475.043)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 295.35,
    cy: 295.35,
    r: 295.35,
    fill: "#633fda"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000070825027795009327310000012950290392375716004_",
    transform: "translate(266.706 613.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M828.852,864.965c.3-12.746-9.711-23.115-19.189-31.642-25.019-22.542-46.155-47.362-76.359-62.45-22.015-11.007-40.114-28.17-58.37-44.331-12.739-11.275-36.417-40.168-55.4-26.954-8.151,5.674-12.2,15.546-14.819,25.123A142.63,142.63,0,0,0,599.7,764.6c.157,9.68,1.3,19.445-.352,28.981-4.664,27.038-59.062,5.59-75.729,3.9-25.479-2.592-51.018-3.273-76.435-6.714-7.18-.975-59.64-1.72-80.473.069-3.422.294-50.284-8.58-78.618,5.686-14.536,7.318-5.991,37.873-6.546,47.7-1.182,20.894-7.111,40.794,1.75,45.226,6.974,3.487,29.516-2.042,52.379-1.755,10.113.125,144.861,6.763,181.752,3.567,26.232-2.275,65.872-11.837,85.558,13.049,13.634,17.245,3.312,42-3.7,62.832s-4.527,51.538,17.159,55.124c11.03,1.824,21.432-5.035,30.506-11.559q78.81-56.627,157.619-113.25c11.4-8.185,23.953-18.432,24.282-32.482",
    transform: "translate(-278.508 -696.197)",
    fill: "#fff"
  }))))))));
};
export default __webpack_public_path__ + "static/media/clean_next_selected.8a8dfafe.svg";
export { SvgComponent as ReactComponent };